import { MatterJurisdictionEntrySource } from '@/analytics/enums/matter-jurisdiction.enums'
import { AnalyticsEvent, type AnalyticsEventProperties } from '@/analytics/schema/events.schema'
import { inferJurisdictionKind } from '@/jurisdiction-mappings/jurisdiction-maps'

const kMatterJurisdictionEntrySources = new Set<string>(Object.values(MatterJurisdictionEntrySource))

// Date the jurisdiction field shipped in the matter dialog. See README.md ("Matter jurisdiction
// nudges") for why this is an analysis-time segmentation dimension only, never an eligibility check.
const kJurisdictionFieldLaunchTimestamp = new Date('2026-05-20T00:00:00Z').getTime()

export function matterCreatedBeforeLaunch(createdAt: number): boolean {
  return createdAt < kJurisdictionFieldLaunchTimestamp
}

export function getMatterJurisdictionAnalyticsProps(defaultJurisdiction: string | null): AnalyticsEventProperties[AnalyticsEvent.MatterCreated] {
  const jurisdictionId = defaultJurisdiction ?? ''
  const kind = inferJurisdictionKind(jurisdictionId)

  return {
    matterJurisdictionId: jurisdictionId,
    isStateMatterJurisdiction: kind === 'state',
    isFederalMatterJurisdiction: kind === 'federal',
    isMatterJurisdictionUndecided: defaultJurisdiction == null,
    matterStateJurisdiction: kind === 'state' ? jurisdictionId : '',
    matterFederalJurisdiction: kind === 'federal' ? jurisdictionId : '',
  }
}

export function getDefaultJurisdictionAnalyticsProps(defaultJurisdiction: string | null): AnalyticsEventProperties[AnalyticsEvent.DefaultJurisdictionSaved] {
  const jurisdictionId = defaultJurisdiction ?? ''
  const kind = inferJurisdictionKind(jurisdictionId)

  return {
    defaultJurisdictionId: jurisdictionId,
    isStateDefaultJurisdiction: kind === 'state',
    isFederalDefaultJurisdiction: kind === 'federal',
    isDefaultJurisdictionUndecided: defaultJurisdiction == null,
    defaultStateJurisdiction: kind === 'state' ? jurisdictionId : '',
    defaultFederalJurisdiction: kind === 'federal' ? jurisdictionId : '',
  }
}

export function resolveMatterJurisdictionEntrySource(source: string | null): MatterJurisdictionEntrySource {
  if (source != null && kMatterJurisdictionEntrySources.has(source)) {
    return source as MatterJurisdictionEntrySource
  }
  return MatterJurisdictionEntrySource.Direct
}
